import React, { useState, useEffect, useRef } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useInView } from "react-intersection-observer";
import Tooltip from '@mui/material/Tooltip';
import TR from './../../Trans';
import { ReactComponent as VocIcon } from './../../assets/voc.svg';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditIcon from '@mui/icons-material/Edit';
import Countdown from '../player/Countdown';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import PerformanceListItemTime from './PerformanceListItemTime';
import SvgIcon from '@mui/material/SvgIcon';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Avatar from '@mui/material/Avatar';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as EqualizerIcon } from './../../assets/equalizer.svg';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import StarIcon from '@mui/icons-material/Star';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import IntervalService from './../../services/intervals';
import SmartQRestore from '../dialogs/SmartQRestore';
import favoritesStore from '../../stores/favorites';
import sessionStore from '../../stores/session';
import settingsStore from '../../stores/settings';
import performanceStore from '../../stores/performance';
import playerStore from './../../stores/player';
import accountStore from '../../stores/account';

const PerformanceListItem = React.memo(function PerformanceListItem(props) {

  const thisPerformance = performanceStore((state) => state.playQueue?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const account = accountStore((state) => state.account);
  const deleteFavorite = favoritesStore((state) => state.deleteFavorite);
  const setFavorite = favoritesStore((state) => state.setFavorite);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const moveUp = performanceStore((state) => state.moveUp);
  const moveDown = performanceStore((state) => state.moveDown);
  const moveToTop = performanceStore((state) => state.moveToTop);
  const moveToSecond = performanceStore((state) => state.moveToSecond);
  const moveToBottom = performanceStore((state) => state.moveToBottom);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const setPerformanceToBeChanged = performanceStore((state) => state.setPerformanceToBeChanged);
  const smartQRestore = performanceStore((state) => state.smartQRestore);
  const isFavorite = favoritesStore(
    (state) => state.tracks?.find(x => x.track_id == thisPerformance?.track.track_id && x.is_favorite == 1)
  );
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setFrom = playerStore((state) => state.setFrom);
  const currentPitch = playerStore((state) => state.currentPitch);
  const settingsSmartQEnabled = settingsStore((state) => state.settings?.smartq_enabled);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);
  const isPlaying = playerStore((state) => props.index == 0 ? state.isPlaying : undefined);
  const isFocused = playerStore((state) => state.isFocused);

  const [showEqualizer, setShowEqualizer] = useState(true);

  const [date, updateDate] = useState();

  function onTheMinute(callback) {
    setTimeout(() => {
      callback.call(null);
      onTheMinute(callback);
    }, 30 * 1000);
  }

  useEffect(() => {
    onTheMinute(() => {
      updateDate(new Date());
    });
  }, []);

  const [isSmartQRestoreOpen, setIsSmartQRestoreOpen] = useState(false);

  const handleOpenSmartQRestore = (e) => {
    e.stopPropagation();
    setIsSmartQRestoreOpen(true);
  };

  const handleCloseSmartQRestore = () => {
    setIsSmartQRestoreOpen(false);
  };

  const handleSetFavorite = (event) => {
    event.stopPropagation();
    if (isFavorite) {
      deleteFavorite(sessionToken, thisPerformance?.track);
    } else {
      setFavorite(sessionToken, thisPerformance?.track);
    }
  };

  const itemRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
    if (itemRef) {
      if (itemRef.current) {
        itemRef.current.style.background = "unset";
      }
    }
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
    if (itemRef) {
      if (itemRef.current) {
        itemRef.current.style.background = "rgba(255, 255, 255, 0.08) !important";
      }
    }
  };

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const fromNowToMinutes = (secs) => {
    let timeObject = new Date();
    const milliseconds = secs * 1000;
    timeObject = new Date(timeObject.getTime() + milliseconds);
    return timeObject.getHours() + ":" + (timeObject.getMinutes() < 10 ? "0" + timeObject.getMinutes() : timeObject.getMinutes());
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  /*   const countdownStr = () => {
      if (nextPerformance) {
        if (nextPerformance.unique_id === thisPerformance?.unique_id) {
          return countdown + " s - ";
        }
      }
      return "";
    }; */

  const vocalImg = () => {
    if (thisPerformance?.track) {
      if (thisPerformance?.track.flags) {
        if (thisPerformance?.track.flags.includes("voc_avail")) {
          return <Tooltip title={TR.cm_vocal_version_available}><SvgIcon className="muvika-icon track-list-item-icon" component={VocIcon} /></Tooltip>;
        }
      }
    }
  };

  const editedImg = () => {
    if (thisPerformance) {
      if (thisPerformance?.flags) {
        if (thisPerformance?.flags.includes("track_changed")) {
          return <Tooltip title={TR.cm_sb_track_changed}><SvgIcon className="muvika-icon track-list-item-icon" component={EditIcon} /></Tooltip>;
        }
      }
    }
  };

  const primaryText = () => {
    let isManual = false;
    if (thisPerformance?.flags) {
      if (thisPerformance?.flags.includes("manual")) {
        isManual = true;
      }
    }
    if (thisPerformance?.position == 0) {
      return <div>
        <Countdown performance={thisPerformance} /> <span><span className="muvika-bold-title">{thisPerformance?.profile.name}</span> - {thisPerformance?.track.title} {vocalImg()} {editedImg()}</span>
      </div>;
    } else {
      if (settingsSmartQEnabled) {
        if (isManual) {
          return <span>
            <span>{(thisPerformance?.position + 1) + ". "}</span><Countdown performance={thisPerformance} /> <span><span className="muvika-white-title">{thisPerformance?.profile.name}</span> - {thisPerformance?.track.title} {vocalImg()} {editedImg()}</span>
            <img onClick={handleOpenSmartQRestore} src="./smartq-disabled-16.png" alt="" />
          </span>;
        }
      }
      return <div>
        <span>{(thisPerformance?.position + 1) + ". "}</span> <Countdown performance={thisPerformance} /> <span><span className="muvika-white-title">{thisPerformance?.profile.name}</span> - {thisPerformance?.track.title} {vocalImg()} {editedImg()}</span>
      </div>;
    }
  };

  const secondaryText = thisPerformance?.track.artist;

  const changeablePerformance = () => {
    return <ListItemButton sx={{
      lineHeight: 0.9,
      paddingLeft: "0.75rem !important",
      margin: 0,
      background: "var(--selected-color)",
      fontWeight: "var(--selected-font-weight) !important",
      color: "black",
      fontSize: "1rem"
    }}>
      <ListItemText primary={TR.cm_select_new_song + "..."} secondary={primaryText} />
      <IconButton onClick={() => {
        setPerformanceToBeChanged(null);
      }} >
        <CancelIcon />
      </IconButton>
    </ListItemButton>;
  };

  const renderStarIcon = () => {
    if (isFavorite) {
      return <StarIcon className="muvika-yellow-star" />;
    } else {
      return <StarIcon className="muvika-empty-star" />;
    }
  };

  const renderFavoritesStar = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
          {renderStarIcon()}
        </IconButton>;
      }
    } else {
      return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
        {renderStarIcon()}
      </IconButton>;
    }
  };

  /*   const getCountdownMinutes = () => {
      if (!nextPerformance) {
        if (props.index == 0) {
          return 0;
        } else {
          return thisPerformance?.incoming + ((props.index) * props.autoPlaySecs) - currentTime;
        }
      } else {
        if (props.index == 0) {
          return countdown;
        } else {
          return thisPerformance?.incoming + (props.index * props.autoPlaySecs) + countdown - currentTime;
        }
      }
    }; */

  const handleMoveToTop = () => {
    IntervalService.clearAllIntervals();
    setIsPlaying(false);
    setFrom(0);
    setCurrentTime(0);
    if (!playerStore.getState().isStopped.isStopped) {
      setIsStopped(true);
    }
    moveToTop(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveToBottom = () => {
    if (thisPerformance?.position == 0) {
      setIsPlaying(false);
      setFrom(0);
      setCurrentTime(0);
      if (!playerStore.getState().isStopped.isStopped) {
        setIsStopped(true);
      }
    }
    moveToBottom(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveUp = () => {
    if (thisPerformance?.position == 1) {
      setIsPlaying(false);
      setFrom(0);
      setCurrentTime(0);
      if (!playerStore.getState().isStopped.isStopped) {
        setIsStopped(true);
      }
    }
    moveUp(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveSecond = () => {
    if (thisPerformance?.position == 0) {
      setIsPlaying(false);
      setFrom(0);
      setCurrentTime(0);
      if (!playerStore.getState().isStopped.isStopped) {
        setIsStopped(true);
      }
    }
    moveToSecond(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveDown = () => {
    if (thisPerformance?.position == 0) {
      setIsPlaying(false);
      setFrom(0);
      setCurrentTime(0);
      if (!playerStore.getState().isStopped.isStopped) {
        setIsStopped(true);
      }
    }
    moveDown(sessionToken, thisPerformance?.unique_id);
  };

  const renderMoveToFirst = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveToTop();
      }}>{TR.cm_move_to_now_playing}</MenuItem>;
    }
  };

  const renderMoveToSecond = () => {
    if (props.count > 1 && thisPerformance?.position != 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveSecond();
      }}>{TR.cm_move_to_second}</MenuItem>;
    }
  };

  const renderMoveUp = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveUp();
      }}>{TR.cm_move_up}</MenuItem>;
    }
  };

  const renderMoveDown = () => {
    if (thisPerformance?.position < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveDown();
      }}>{TR.cm_move_down}</MenuItem>;
    }
  };

  const renderMoveToLast = () => {
    if (thisPerformance?.position != props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveToBottom();
      }}>{TR.cm_move_to_bottom}</MenuItem>;
    }
  };

  const renderDelete = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      handleMenuClose();
      if (thisPerformance?.position == 0) {
        setIsPlaying(false);
        setFrom(0);
        setCurrentTime(0);
        if (!playerStore.getState().isStopped.isStopped) {
          setIsStopped(true);
        }
        addPerformanceToHistory(sessionToken, thisPerformance);
      }
      deletePerformance(sessionToken, thisPerformance?.unique_id);
    }}>{TR.cm_delete}</MenuItem>;
  };

  const showIcon = () => {
    if (thisPerformance?.position == 0) {
      if (isPlaying.isPlaying) {
        if (showEqualizer) {
          return <div style={{ position: "absolute", zIndex: 999 }}><img className="muvika-icon performance-list-item-icon" src="./eq.gif" /></div>;
        } else {
          return <PauseIcon className="muvika-performance-play-icon" />;
        }
      } else {
        return <PlayArrowIcon className="muvika-performance-play-icon" />;
      }
    }
  };

  const handlePlayPause = (e) => {
    e.stopPropagation();
    if (isFocused) {
      if (isPlaying.isPlaying) {
        setIsPlaying(false);
      } else {
        setIsPlaying(true);
        setIsStopped(false);
      }
    }
  };

  const renderAvatar = () => {
    if (account) {
      if (!(account.subscription.valid == 0)) {
        if (thisPerformance?.position == 0) {
          return <ListItemAvatar onMouseOver={() => setShowEqualizer(false)} onMouseOut={() => setShowEqualizer(true)} onClick={handlePlayPause} className="muvika-track-avatar-item">
            <Avatar className="muvika-track-avatar">            <img className="muvika-track-avatar-image" src={thisPerformance?.track.url_thumb_image} alt="" />
              {showIcon()}
            </Avatar>
          </ListItemAvatar>;
        }
      }
    }
  };

  const primaryRightTop = (thisPerformance?.pitch != 0 ? (thisPerformance?.pitch > 0 ? "+" : "") + thisPerformance?.pitch + " " : "");

  const renderPrimaryRight = () => {
    let nDate = date;
    if (thisPerformance?.position == 0) {
      return <div>
        {TR.cm_now}
      </div>;
    } else {
      return <PerformanceListItemTime performance={thisPerformance} index={props.index} autoPlaySecs={props.autoPlaySecs} />;
      /*  return <div>
         <span className="muvika-performance-list-item-minutes">{toMinutes(getCountdownMinutes()) + " min"}</span> <AccessTimeIcon className="muvika-access-time-icon" /> <span className="muvika-performance-list-item-minutes">{fromNowToMinutes(getCountdownMinutes())}</span>
       </div>; */
    }
  };

  const renderPitchKcode = () => {
    return <span>{primaryRightTop + " " + thisPerformance?.track.kcode}</span>;
  };

  const performanceItem = () => {
    console.log("render again");
    return <ListItemButton
      ref={itemRef}
      sx={{
        lineHeight: 0.9,
        paddingLeft: "0.75rem !important",
        margin: 0,
        bgcolor: isMenuOpen ? 'rgba(100, 100, 100, 0.08) !important' : 'unset'
      }}
      selected={thisPerformance?.position == 0}
      onClick={() => {
        props.onEditPerformance(thisPerformance);
      }}>
      {renderAvatar()}
      <ListItemText className={thisPerformance?.position > 0 ? "muvika-list-l-left" : "muvika-list-left-l-top"} primary={primaryText()} secondary={secondaryText} />
      <ListItemText
        className={thisPerformance?.position > 0 ? "muvika-list-right" : "muvika-list-right-top"}
        primary={
          renderPrimaryRight()
        }
        secondary={renderPitchKcode()}
      />
      {renderFavoritesStar()}
      <IconButton
        id={"menu-button-" + thisPerformance?.unique_id}
        className="muvika-performance-menu-button"
        color="white"
        component="label"
        size="small"
        aria-controls={isMenuOpen ? "menu-" + thisPerformance?.unique_id : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          openMenu(e);
        }} >
        <MenuIcon />
      </IconButton>
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
        id={"menu-" + thisPerformance?.unique_id}
        open={isMenuOpen}
        anchorEl={anchorEl}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleMenuClose();
        }}
        MenuListProps={{
          'aria-labelledby': 'menu-button-' + thisPerformance?.unique_id,
        }}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        {renderMoveToFirst()}
        {renderMoveToSecond()}
        {renderMoveUp()}
        {renderMoveDown()}
        {renderMoveToLast()}
        {renderDelete()}
      </Menu>
    </ListItemButton>;
  };

  const renderListItem = () => {
    if (performanceToBeChanged) {
      if (performanceToBeChanged.unique_id == thisPerformance?.unique_id) {
        return changeablePerformance();
      }
    }
    return performanceItem();
  };

  const handleSmartQRestore = () => {
    smartQRestore(sessionToken, thisPerformance?.unique_id);
    setIsSmartQRestoreOpen(false);
  };

  const renderItem = () => {
    if (thisPerformance) {
      return <div className="muvika-performance-list-item">
        <SmartQRestore
          open={isSmartQRestoreOpen}
          onClose={handleCloseSmartQRestore}
          onConfirmation={handleSmartQRestore}
        />
        {renderListItem()}
      </div>;
    }
  };

  return (
    <Draggable
      key={props.key}
      draggableId={props.draggableId}
      index={props.index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {renderItem()}
        </div>
      )}
    </Draggable>
  );
});


export default PerformanceListItem;